import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Card, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import { rentalIncomeData } from "./chart-mock-data";
import SectionTitle from "../section-title";

export function RentalIncomeChart() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 4,
        height: { xs: 360, sm: 480 },
      }}
    >
      <SectionTitle title="Rental Income Overview" />

      <Typography
        variant="caption"
        color="success.main"
        sx={{ fontSize: { xs: 11, sm: 12 } }}
      >
        +8% vs last year
      </Typography>

      <Box height={{ xs: 260, sm: 360 }} mt={2}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={rentalIncomeData}>
            <XAxis
              dataKey="month"
              tick={{ fontSize: isMobile ? 10 : 12 }}
              axisLine={false}
              tickLine={false}
            />

            {!isMobile && (
              <YAxis
                tick={{ fontSize: 12 }}
                axisLine={false}
                tickLine={false}
              />
            )}

            <Tooltip
              contentStyle={{
                fontSize: isMobile ? 11 : 12,
                borderRadius: 8,
              }}
            />

            <Area
              type="monotone"
              dataKey="expected"
              stroke="#94A3B8"
              fill="#CBD5E1"
              strokeDasharray="4 4"
              strokeWidth={isMobile ? 1.5 : 2}
              dot={false}
            />

            <Area
              type="monotone"
              dataKey="collected"
              stroke="#19429bbd"
              fill="#3B82F6"
              strokeWidth={isMobile ? 2 : 3}
              dot={{ r: isMobile ? 2 : 3 }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
}
